"use client"

import { useResponsive } from "@/core-nextv3/util/useResponsive";
import { usePathname } from "next/navigation";
import { useCookies } from "react-cookie";

const MainLayout = ({ children, topHeaderData }:any) => 
{
    const { isClient } 		     = useResponsive();
    const pathname 				 = usePathname();
    const [ cookies, setCookie ] = useCookies([ "topBarVisible" ]);
    const hasTopHeader: boolean = [ "/" ].includes(
        pathname
    ) && !cookies.topBarVisible;

    if (!isClient) return null;

    const onlyPathsFull : boolean = [ "/checkout/", "/mobile/checkout/" ].includes(
        pathname
    );

    return (
        <div className={(onlyPathsFull ? "fullPage" : "") + " " + (topHeaderData?.published && hasTopHeader ? "hasTopHeader" : "noTopHeader")}>
            {children}
        </div>
    );
}

export { MainLayout };
